<template>
<div class="year-list">
    <button @click="toggleShow(year,$event)" v-bind:class="['year-list__trigger', { active: show_contents.indexOf(year) >= 0 }]">{{year}}年<span class="year-list__trigger--sub">{{ japan }}</span></button>
    <transition><div class="year-list__content" v-show="show_contents.indexOf(year) >= 0">  
        <ul class="year-list__content--text" v-html="caption"></ul>
        <h2 class="year-list__content--title" v-if="year>=1963 && year<=2012"><svg class="icon icon-mfj-riding"><use xlink:href="#icon-mfj-riding"></use></svg>{{ year }}</h2>
        <ul v-bind:class="['lookBook', { currentBook: year == 1963 }, { currentBook2: year == 1978 }, { currentBook3: year == 1985 }, { currentBook4: year == 1994 }, { currentBook5: year == 2001 }, { currentBook6: year == 2012 }]"></ul>
    </div></transition>
</div>
</template>

<script>
    import items from '@/assets/data.json'
    export default {
        data: function() {
            return {
                show_contents: [1961,1962,1963,1978,1985,1994,2001,2012,2021] //年の初期表示
            }
        },
        props: {
            year: {
              type: String,
              default: '',
              required: true
            },
            caption: {
              type: String,
              default: '',
              required: false
            },
        },
        computed: {
            japan() {
              const year = this.year;
              var yearNum = '';
              if (year == 2019) {
                return "平成31年/令和元年";
              }else if (year >= 2019) {
                yearNum = year - 2018;
                return "令和"+yearNum+"年";
              }else if (year == 1989) {
                return "昭和64年/平成元年";
              }else if (year >= 1989) {
                yearNum = year - 1988;
                return "平成"+yearNum+"年";
              } else {
                yearNum = year - 1925;
                return "昭和"+yearNum+"年";
              }
              
            },
        },
        methods: { 
            toggleShow: function (data, event) {
                if (this.show_contents.indexOf(data) >= 0) {
                    this.show_contents = this.show_contents.filter(n => n !== data)
                }else {
                    this.show_contents.push(data)
                }
                var lookBook = event.currentTarget.nextElementSibling.lastElementChild;
                if(!lookBook.children.length){
                    var result = '',
                        selected = data;
                    items.forEach(function(item) {
                        if(item.year == selected){
                        var src = item.year+'_'+item.no+'_'+item.global;
                        result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
                        }
                        
                    });
                    lookBook.insertAdjacentHTML('afterbegin', result);
                }
            },
        },
    }   
</script>
